import { yupResolver } from "@hookform/resolvers/yup";
import { CustomInput } from "components/CustomInput";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import FileUpload from "components/UploadArquivos";
import { PrimaryButton } from "components/Button/style";
import { useEffect } from "react";
import { ContainerTextForm } from "../style";
import { CustomDatePicker } from "components/DatePicker";
import { emissaoManual } from "../../../validate/validator";
import { IEmissaoManual } from "../../../interfaces/IEmissaoManual";

interface Props {
  handleSubmitEmissaoManual: (dados: IEmissaoManual) => void;
  ano: number;
  handleClose: () => void;
  dataEmissao: Date;
}

export function BodyEmissaoManual({
  handleSubmitEmissaoManual,
  ano,
  handleClose,
  dataEmissao,
}: Props) {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors, isSubmitted },
  } = useForm<IEmissaoManual>({
    resolver: yupResolver(emissaoManual),
  });

  useEffect(() => {
    setValue("dataEmissao", new Date());
    setValue("exercicio", ano);
  }, [dataEmissao]);

  return (
    <form
      onSubmit={handleSubmit((dados) => handleSubmitEmissaoManual(dados))}
      id="formEmissaoManual"
    >
      <ContainerTextForm>Dados da emissão do CRLV</ContainerTextForm>
      <Row>
        <Col md="3">
          <Form.Group>
            <Form.Label>Data de emissão</Form.Label>
            <Controller
              control={control}
              name="dataEmissao"
              render={({ field: { onChange, value } }) => (
                <CustomDatePicker
                  onChange={onChange}
                  selected={value}
                  placeholder="Selecione a data"
                  mensagemErro={errors.dataEmissao?.message}
                />
              )}
            />
          </Form.Group>
        </Col>
        <Col md="2">
          <Form.Group>
            <Form.Label>Exercício</Form.Label>
            <CustomInput
              type="text"
              {...register("exercicio")}
              isValid={isSubmitted && !errors.exercicio}
              isInvalid={!!errors.exercicio}
              iconeDireito={false}
              iconeEsquerdo={false}
              value={ano}
              disabled
              mensagemErro={errors.exercicio?.message}
            />
          </Form.Group>
        </Col>
        <Col>
          <div className="arquivoContainer">
            <span>Arquivo</span>
            <Controller
              control={control}
              name="arquivo"
              render={({ field: { onChange } }) => (
                <FileUpload
                  onFileUpload={(file) => onChange(file)}
                  mensagemErro={errors?.arquivo?.message as string}
                  inputAccept=".jpg, .jpeg, .png, .pdf"
                />
              )}
            />
          </div>
        </Col>
      </Row>
      <div className="d-flex justify-content-end mt-4">
        <PrimaryButton
          type="button"
          className="me-2"
          outline
          variante="primary"
          onClick={handleClose}
        >
          Cancelar
        </PrimaryButton>
        <PrimaryButton type="submit">Confirmar emissão</PrimaryButton>
      </div>
    </form>
  );
}
